var _excluded = ["size"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
var CardGraphicIcon = function CardGraphicIcon(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 48 : _props$size,
    otherProps = _objectWithoutProperties(props, _excluded);
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "CARD-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.002 3.065a2 2 0 012 2v13.87a2 2 0 01-2 2H1.998a2 2 0 01-2-2V5.065a2 2 0 012-2zm1 5.6H.998v10.27a1 1 0 00.883.993l.117.007h20.004a1 1 0 001-1V8.665zm-1-4.6H1.998a1 1 0 00-1 1v2.6h22.004v-2.6a1 1 0 00-.883-.993l-.117-.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.466 15.334a.5.5 0 01.09.992l-.09.008H5.1a.5.5 0 01-.09-.992l.09-.008h5.367zm3.068-3.067a.5.5 0 01.09.992l-.09.008H5.099a.5.5 0 01-.09-.992l.09-.008h8.435z"
  }))));
};
CardGraphicIcon.displayName = "CardGraphicIcon";
CardGraphicIcon.displayName = "CardGraphicIcon";
CardGraphicIcon.iconName = "Card";
export default CardGraphicIcon;